var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ selected: _vm.isSelected },on:{"click":_vm.selectTicket}},[_vm._v(" "+_vm._s(_vm.ticket.userName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }